import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.scss';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import MaintenanceMessage from './components/elements/MaintenanceMessage';

const maintenance = false;

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    { maintenance && <MaintenanceMessage /> }
    { !maintenance && <App />}
  </React.StrictMode>
);
